// extracted by mini-css-extract-plugin
module.exports = {"fitment_name":"garage-info_fitment_name__0sD4k","category_name":"garage-info_category_name__ePbvc"};